import React, { useState } from "react";
import styles from "../../asset/Contact/Contact.module.scss";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    country: "",
    phone: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.companyName.trim()) newErrors.companyName = "Company name is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/api/save_contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          first_name: formData.firstName,
          last_name: formData.lastName,
          company_name: formData.companyName,
          country: formData.country || null,
          phone_no: formData.phone,
          email: formData.email,
          message: formData.message,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success(data.message);
        setFormData({
          firstName: "",
          lastName: "",
          companyName: "",
          country: "",
          phone: "",
          email: "",
          message: "",
        });
        setErrors({});
        return;
      }

      if (response.status === 422) {
        toast.error(data.message);
        return;
      }

      if (response.status === 429) {
        toast.error(data.message || "Too many attempts.");
        return;
      }

      toast.error(data.message || "Something went wrong.");
    } catch (error) {
      toast.error("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={styles.contactSection}>
      <div className={styles.container}>
        <div className={styles.formWrapper}>
          <h2 className={styles.heading}>
            Responsive customer support is not just policy at <br />
            <span>Saidigitizing – it's a culture, and a promise.</span>
          </h2>

          <p className={styles.subheading}>
            Call, email or use the form below.
          </p>

          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.inputGrid}>
              <div>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name*"
                  value={formData.firstName}
                  onChange={handleChange}
                  className={errors.firstName ? styles.errorInput : ""}
                />
                {errors.firstName && (
                  <p className={styles.errorText}>{errors.firstName}</p>
                )}
              </div>

              <div>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name*"
                  value={formData.lastName}
                  onChange={handleChange}
                  className={errors.lastName ? styles.errorInput : ""}
                />
                {errors.lastName && (
                  <p className={styles.errorText}>{errors.lastName}</p>
                )}
              </div>

              <div>
                <input
                  type="text"
                  name="companyName"
                  placeholder="Company Name*"
                  value={formData.companyName}
                  onChange={handleChange}
                  className={errors.companyName ? styles.errorInput : ""}
                />
                {errors.companyName && (
                  <p className={styles.errorText}>{errors.companyName}</p>
                )}
              </div>

              <input
                type="text"
                name="country"
                placeholder="Country (Optional)"
                value={formData.country}
                onChange={handleChange}
              />

              <div>
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number*"
                  value={formData.phone}
                  onChange={handleChange}
                  className={errors.phone ? styles.errorInput : ""}
                />
                {errors.phone && (
                  <p className={styles.errorText}>{errors.phone}</p>
                )}
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address*"
                  value={formData.email}
                  onChange={handleChange}
                  className={errors.email ? styles.errorInput : ""}
                />
                {errors.email && (
                  <p className={styles.errorText}>{errors.email}</p>
                )}
              </div>
            </div>

            <textarea
              name="message"
              placeholder="Tell us about your project ..."
              className={styles.textarea}
              value={formData.message}
              onChange={handleChange}
            />

            <button
              type="submit"
              className={styles.submitBtn}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>

        <div className={styles.infoWrapper}>
          <h4>Saidigitizing</h4>
          <p>US Toll : +1 (949) 309-0570</p>
          {/* <p>Toll Free : 1-866-731-3025</p> */}
          <p>
            Email : <a href="mailto:saidigitizing.orders@gmail.com">saidigitizing.orders@gmail.com</a>
          </p>
                    <p>Address : 14582 Beach Blvd, Midway City, CA 92655, USA</p>

        </div>
        
      </div>
    </section>
  );
};

export default ContactForm;